import { render, staticRenderFns } from "./panels.vue?vue&type=template&id=386e3342&scoped=true"
import script from "./panels.vue?vue&type=script&lang=js"
export * from "./panels.vue?vue&type=script&lang=js"
import style0 from "./panels.vue?vue&type=style&index=0&id=386e3342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386e3342",
  null
  
)

export default component.exports